<h2 class="mb-4">All registration forms</h2>
<table id="dt-in-progress" datatable class="table row-bordered table-hover" [dtOptions]="dataTableOptions">
</table>